<template>
    <div class="products">
        <div class="columns is-multiline">
            <div class="column is-12">
                <div class="has-text-primary is-size-3 is-uppercase">Bitte wählen Sie das gewünschte Produkt</div>
            </div>
        </div>
        <div v-if="productsActive">
            <div v-if="productsFound <= '0'" class="columns">
                <div class="column" align="center">
                    <p class="is-size-5 is-uppercase">kein Produkt gefunden, das dem gewählten Filter entspricht</p>
                </div>
            </div>
            <div class="columns is-multiline">
                <div class="column is-one-fifth is-clickable has-products" v-for="(prod, index) in menuOrderProducts" :key="index" @click="currentProduct = prod; setStep()">
                    <div :class="`cat-box is-uppercase has-background-grey-light`" align="center">
                        <div v-if="prod.images[0]"><img class="product-image" :src="prod.images[0].src" /></div>
                        <div>
                            <div class="has-text-weight-bold">{{ prod.name }} </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else align="center">
            <LoadingEffect />
        </div>
        <FilterTab class="filter-tab" />
    </div>
    
</template>
<script>
import FilterTab from '@/components/FilterTab'
import LoadingEffect from './loadingEffect.vue'
export default {
    components: { FilterTab, LoadingEffect },
     data () {
        return {
            productsActive: false
        }
    },
    mounted () {
        this.loadingDelay()
    },
    computed: {
        currentProduct: {
            set (val) {
                this.$store.commit('setCurrentProduct', val)
            },
            get () {
                return this.$store.state.currentProduct
            }
        },
        currentStep: {
            set (val) {
                this.$store.commit('setCurrentStep', val)
            },
            get () {
                return this.$store.state.currentStep
            }
        },
        filteredProducts () {
            return this.$store.getters.filteredProducts
        },

        menuOrderProducts () {
            const orderedProducts = this.filteredProducts
            return orderedProducts.sort((x,y) => { return x.menuOrder - y.menuOrder})
        },
        
        categories () {
            return this.$store.state.categories
        },
        catIdSchraubenart () {
            return this.$store.state.catIdSchraubenart
        },
        categorySchraubenart () {
            return this.categories.find(cat => cat.id === this.catIdSchraubenart)
        },
        productsFound () {
            const products = this.filteredProducts.length
            return products
        }
    },
    methods: {
        setStep () {
            this.currentStep = 'ProductDetails'
        },
        loadingDelay () {
            setTimeout(() => {this.productsActive = !this.productsActive},2000)
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/main.sass"

.product-image
    height: 150px
    width: 300px

.no-variations
    font-size: 25px
    color: red
    padding-top: 2px
    width: 50px
    height: 50px
    border-radius: 50%
    align-items: center
    background-color: white
    position: absolute !important
    font-weight: 700
    border-color: $grey-light
    border-style: solid
    margin-top: -230px

.filter-tab
    margin-top: 30px

.menu-order
    color: red
</style>
